/** CHECKLIST: conforme / não conforme. FREE_TEXT: cada pergunta é respondida em texto livre. */
export const QUIZ_KINDS = ['CHECKLIST', 'FREE_TEXT'] as const
export type QuizKind = (typeof QUIZ_KINDS)[number]

export interface QuizInput {
	title: string
	/** Definido só na criação; o tipo não muda depois */
	kind?: QuizKind
	description?: string
	/** Nota do questionário a partir do mês corrente (1–100); omitida = não altera */
	score?: number
	questions: QuizQuestionInput[]
	branchesId: string[]
}

export interface QuizQuestionInput {
	id?: string
	question: string
	image?: File
	removeImage?: boolean
}

export interface QuizOutput {
	id: string
	title: string
	kind: QuizKind
	/** Nota vigente no mês corrente; null = Direcionada usa os pontos padrão da atividade */
	score: number | null
	questions: QuizQuestionOutput[]
	quizBranches: QuizBranchesOutput[]
	createdAt: string
}

export interface QuizQuestionOutput {
	id: string
	question: string
	imagePath?: string
}

export interface QuizBranchesOutput {
	id: string
	name: string
}

export interface QuizParams {
	page?: number
	limit?: number
	branchId?: string
	kind?: QuizKind
	search?: string
}

export interface QuizListOutput {
	items: QuizOutput[]
	pagination: {
		page: number
		limit: number
		total: number
		totalPages: number
	}
}
